var _rect, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFuzuNotification = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 63,
  height: 61,
  fill: "none"
}, props), /*#__PURE__*/React.createElement("g", {
  className: "fuzuNotification_svg__pwa-app-icon-combined"
}, /*#__PURE__*/React.createElement("g", {
  className: "fuzuNotification_svg__app-icon"
}, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 56,
  height: 56,
  y: 5,
  fill: "#FFE140",
  rx: 8
})), /*#__PURE__*/React.createElement("g", {
  className: "fuzuNotification_svg__fuzu-logo-word fuzuNotification_svg__1"
}, /*#__PURE__*/React.createElement("g", {
  className: "fuzuNotification_svg__Clip fuzuNotification_svg__path fuzuNotification_svg__group"
}, /*#__PURE__*/React.createElement("mask", {
  id: "fuzuNotification_svg__a",
  width: 44,
  height: 14,
  x: 6,
  y: 26,
  className: "fuzuNotification_svg__a",
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "luminance"
  }
}, _g || (_g = /*#__PURE__*/React.createElement("g", {
  className: "fuzuNotification_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M6 26.053h44v13.894H6z",
  className: "fuzuNotification_svg__Vector"
})))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  className: "fuzuNotification_svg__Group",
  mask: "url(#fuzuNotification_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#333",
  d: "m13.89 30.295 1.83-3.638H5.95V39.42h4.039v-3.558h4.562v-3.557H9.99v-2.01zm9.326 4.321c0 .965-.563 1.508-1.306 1.508s-1.307-.543-1.307-1.508v-7.959h-4.04v8.1c0 3.538 2.613 5.005 5.347 5.005 2.732 0 5.347-1.487 5.347-5.004v-8.1h-4.041zm22.794-7.959v7.96c0 .964-.563 1.507-1.306 1.507s-1.306-.543-1.306-1.508v-7.959h-4.041v8.1c0 3.538 2.613 5.005 5.347 5.005 2.733 0 5.347-1.487 5.347-5.004v-8.1zm-16.24 0-1.87 3.638h4.422l-4.704 9.125h10.834v-3.618H33.93l4.724-9.145h-8.885Z",
  className: "fuzuNotification_svg__Vector"
})))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
  className: "fuzuNotification_svg__new-notif"
}, /*#__PURE__*/React.createElement("rect", {
  width: 16.5,
  height: 16.5,
  x: 45.75,
  y: 0.75,
  fill: "#E71D36",
  rx: 8.25
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M52.702 6.25V5.21h2.08v7.29h-1.15V6.25z",
  className: "fuzuNotification_svg__1"
}), /*#__PURE__*/React.createElement("rect", {
  width: 16.5,
  height: 16.5,
  x: 45.75,
  y: 0.75,
  stroke: "#fff",
  strokeWidth: 0.5,
  rx: 8.25
})))));
export default SvgFuzuNotification;